import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["showcaseAthleteRelationItem"];

  connect() {}

  removeShowcaseAthleteRelationItem(event) {
    event.preventDefault();
    const item = event.target.closest(".showcase_athlete_relation_item");
    item.remove();
  }

  increment(e) {
    e.target.href = e.target.href.replace(
      /index=\d+/,
      `index=${this.showcaseAthleteRelationItemTargets.length + 1}`
    );
  }
}
